import { EmptyState, formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import { VaniaLoadingSystem, VaniaTableSkeleton } from '../../../app/components/loading';
import type { RoleApiResponse } from '../../roles/api/roles.api';

export interface TenantRolesSectionProps {
  roles: RoleApiResponse[];
  loading: boolean;
  error: string | null;
}

export function TenantRolesSection({ roles, loading, error }: TenantRolesSectionProps) {
  const activeCount = roles.filter((role) => role.is_active).length;
  const systemCount = roles.filter((role) => role.is_system).length;

  return (
    <div className="vania-tenant-roles-content">
      <div className="vania-tenant-roles-header">
        <div>
          <h2 className="vania-tenant-workspace-card-title">نقش‌ها</h2>
        </div>
        <div className="vania-tenant-roles-summary" aria-label="خلاصه نقش‌های تننت">
          <span>کل {formatPersianNumber(roles.length)}</span>
          <span className="is-active">فعال {formatPersianNumber(activeCount)}</span>
          <span className="is-system">سیستمی {formatPersianNumber(systemCount)}</span>
        </div>
      </div>

      {loading ? (
        <VaniaLoadingSystem mode="content" label="در حال بارگذاری نقش‌های تننت">
          <VaniaTableSkeleton columns={5} rows={5} className="vania-tenant-roles-skeleton" />
        </VaniaLoadingSystem>
      ) : error ? (
        <p className="vania-tenants-status vania-tenants-status-error" role="alert">{error}</p>
      ) : roles.length === 0 ? (
        <EmptyState message="نقشی برای این تننت ثبت نشده است." />
      ) : (
        <div className="vania-tenant-roles-table-scroll">
          <table className="vania-tenant-roles-table">
            <thead>
              <tr>
                <th>نام نقش</th>
                <th>شناسه یکتا</th>
                <th>نوع</th>
                <th>وضعیت</th>
                <th>تاریخ ایجاد</th>
              </tr>
            </thead>
            <tbody>
              {roles.map((role) => (
                <tr key={role.id}>
                  <td className="vania-tenant-roles-name">
                    <span>{role.name}</span>
                    {role.description && <small>{role.description}</small>}
                  </td>
                  <td dir="ltr">{role.slug}</td>
                  <td>{role.is_system ? 'سیستمی' : 'اختصاصی'}</td>
                  <td>
                    <span className={`vania-tenant-role-status ${role.is_active ? 'is-active' : 'is-inactive'}`}>
                      <span aria-hidden="true" />
                      {role.is_active ? 'فعال' : 'غیرفعال'}
                    </span>
                  </td>
                  <td dir="ltr">{formatSolarDate(role.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
